export interface AccessGuardMeta {
  /** A list means every permission in it is required, not any one of them. */
  requiresPermission?: string | string[];
}

export interface AccessGuardContext {
  hasPermission: (permission: string) => boolean;
}

/**
 * Pure decision helper for route-level access checks. Returns true when the
 * navigation should be denied (routed to the Forbidden page).
 */
export function resolveAccessDenial(meta: AccessGuardMeta, access: AccessGuardContext): boolean {
  const required = meta.requiresPermission;
  if (!required) return false;

  const permissions = Array.isArray(required) ? required : [required];
  return permissions.some((permission) => !access.hasPermission(permission));
}
